import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import CardBase from "../../CardBase/CardBase";
import { useContext } from "react";
import { GlobalContext } from "../../../../../common/Context";
import CampaignCardsV2 from "../../../../../common/CampaignCardsV2";
import LoadingWheel from "../../../../../common/LoadingWheel/LoadingWheel";
import { green } from "../../../../../../theme/colours";
import { DASHBOARD_CHALLENGES } from "../../../../../../constants/ids";

const ActiveChallenges = (props) => {
  const { activeCampaigns } = props;
  const { t } = useTranslation("Dashboard");
  const { mobileView, tabletView, desktopView, largeView } =
    useContext(GlobalContext);

  const challengeBoxStyle = {
    width: largeView
      ? "73.5%"
      : tabletView
      ? "49%"
      : mobileView
      ? "100%"
      : "68.5%",
    height: mobileView ? "auto" : "100%",
    mb: mobileView && "1rem",
  };
  const challengeAreaStyle = {
    flex: 1,
    padding: "0.5rem 1rem 1rem",
    display: "flex",
    flexDirection: "column",
  };
  const challengesDescStyle = {
    lineHeight: 1.25,
    opacity: 0.5,
    mb: mobileView && "1rem",
  };
  const challengeCardAreaStyle = {
    display: "flex",
    flexWrap: desktopView && "wrap",
    flexDirection: !desktopView && "column",
    justifyContent: "space-between",
    mt: tabletView && "3%",
    flex: 1,
    "& > div:last-child": {
      mt: mobileView ? "2.5%" : desktopView && "1.5%",
    },
  };
  const errorBoxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flexDirection: "column",
  };
  const errorSubTitleStyle = {
    opacity: "50%",
    mt: "0.5rem",
    textAlign: "center",
    width: "350px",
    lineHeight: "1.5",
  };

  return (
    <CardBase
      title={t("activeChallenges")}
      redirect={activeCampaigns?.length && "competitionInfo"}
      headerColor={green[3]}
      boxStyle={challengeBoxStyle}
      areaStyle={challengeAreaStyle}>
      {activeCampaigns ? (
        activeCampaigns.length ? (
          <>
            <Typography sx={challengesDescStyle}>
              {t("activeChallDesc")}
            </Typography>
            <Box sx={challengeCardAreaStyle} id={DASHBOARD_CHALLENGES}>
              {activeCampaigns.slice(0, desktopView ? 4 : 2).map((campaign) => (
                <>
                  <CampaignCardsV2
                    title={campaign.name}
                    type={campaign.score_type}
                    neededScore={campaign.score}
                    prizeDesc={campaign.prizeDesc}
                    entries={campaign.entries}
                    startDate={campaign.start_date.value}
                    endDate={campaign.end_date.value}
                    banner={campaign.banner}
                  />
                </>
              ))}
            </Box>
          </>
        ) : (
          <Box sx={errorBoxStyle}>
            <Typography variant="h4">{t("noChallengesT")}</Typography>
            <Typography sx={errorSubTitleStyle}>
              {t("noChallengesD")}
            </Typography>
          </Box>
        )
      ) : (
        <LoadingWheel width={3} />
      )}
    </CardBase>
  );
};

export default ActiveChallenges;
